import { useParams } from "react-router-dom";

import { TenantRouteParams } from "src/core/utils/tenant/tenantRoute";

/**
 * Récupère le tenantId depuis l'URL tenant-scoped (/tenant/:tenantId/...).
 * Retourne `null` si le paramètre n'est pas présent.
 */
export const useTenantIdFromRoute = (): string | null => {
  const { tenantId } = useParams<TenantRouteParams>();
  return tenantId ?? null;
};

/**
 * Variante stricte : à utiliser dans les pages qui ne doivent JAMAIS être rendues
 * en dehors d'une route tenant-scoped.
 *
 * @throws Error si tenantId est absent de l'URL.
 */
export const useRequiredTenantIdFromRoute = (): string => {
  const tenantId = useTenantIdFromRoute();

  if (!tenantId) {
    throw new Error("[useRequiredTenantIdFromRoute] Missing tenantId in route params");
  }

  return tenantId;
};
